import {ReactNode} from "react";

type CodeSnippetProps = {
    children: ReactNode;
    className?: string;
};

const CodeSnippet = ({ children, className }: CodeSnippetProps) => {
    return (
        <div className={`snippet border rounded-2 my-3 ${className}`}>
            {children}
        </div>
    );
}
export default CodeSnippet;



